import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { GradeService } from './gradeService';
import { GradeKey } from './keys';

export function useGetGrade(id?: number, enabled = true) {
  const getGradeQuery = useQuery({
    queryKey: [GradeKey.GRADE, id],
    queryFn: () => GradeService.getGrade(id).then((response) => response.data),
    enabled: enabled && typeof id === 'number',
  });
  const errorMessage = useErrorMessage(getGradeQuery.error, baseErrorMessages);
  return { ...getGradeQuery, errorMessage };
}
